import React from "react";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <div className="bg-mesh"></div>

      <main id="content-container">

        {/* Hero Section */}
        <section className="section delay-1">
          <div className="section-title">Personal Statement</div>
          <h1>Hi, I’m Selva Saravana Raj.</h1>
          <p className="intro-text">
            Over the past year I have been deeply focused on learning how real software systems are designed, built, and shipped.
            During this time I built and launched three SaaS products, exploring modern development workflows and leveraging
            <span className="highlight"> AI-assisted development</span> to accelerate learning and execution.
          </p>
        </section>

        {/* SaaS Ecosystem */}
        <section className="section delay-2">
          <div className="section-title">The Ecosystem</div>
          <p style={{ color: "var(--text-dim)", marginBottom: "30px", fontSize: "1.1rem", textAlign: "center" }}>
            These products are part of the <span className="highlight">LEADA360 ecosystem</span>, a growing SaaS platform designed to build connected digital tools and services.
          </p>
          <div className="saas-grid">
            <a href="https://leada360.com" target="_blank" rel="noopener noreferrer" className="saas-card">
              <div>
                <h3>LEADA360</h3>
                <p>The core hub of the ecosystem, connecting tools and services.</p>
              </div>
              <span className="purple" style={{ color: "var(--primary)", marginTop: "15px", display: "block" }}>leada360.com →</span>
            </a>
            <a href="https://token.leada360.com" target="_blank" rel="noopener noreferrer" className="saas-card">
              <div>
                <h3>Token</h3>
                <p>Identity and authentication infrastructure for the platform.</p>
              </div>
              <span className="purple" style={{ color: "var(--primary)", marginTop: "15px", display: "block" }}>token.leada360.com →</span>
            </a>
            <a href="https://connect.leada360.com" target="_blank" rel="noopener noreferrer" className="saas-card">
              <div>
                <h3>Connect</h3>
                <p>Integration and digital tool connectivity services.</p>
              </div>
              <span className="highlight" style={{ marginTop: "15px", display: "block" }}>connect.leada360.com →</span>
            </a>
          </div>
        </section>

        {/* Mission & Current Focus */}
        <section className="section delay-3">
          <div className="section-title">Current Focus</div>
          <p style={{ fontSize: "1.2rem", marginBottom: "20px", textAlign: "center", color: "var(--text-main)" }}>
            Building these systems taught me far more than just writing code. It pushed me to understand
            <span className="highlight"> system architecture</span>, product thinking, automation, backend infrastructure, and the realities of shipping scalable software.
          </p>
          <p style={{ fontSize: "1.1rem", color: "var(--text-dim)", marginBottom: "40px", textAlign: "center" }}>
            Currently, I’m focused on building a <span className="highlight">pharmaceutical ERP system</span>, solving real problems around manufacturing workflows, inventory traceability, and operational systems.
          </p>

          <div style={{ padding: "40px", background: "var(--card-bg)", border: "1px solid var(--border)", borderRadius: "20px", textAlign: "center" }}>
            <h2 style={{ fontSize: "1.5rem", marginBottom: "15px", fontFamily: "var(--font-display)", color: "#fff" }}>My Ambition</h2>
            <p style={{ fontSize: "1.1rem", color: "var(--text-main)", margin: "0 auto", maxWidth: "600px" }}>
              My long-term goal is simple but ambitious — to become one of the
              <span className="highlight"> strongest builders in technology</span> and to create meaningful businesses through software.
            </p>
          </div>
        </section>

        {/* Recruiter Call to Action */}
        <section className="section delay-4" style={{ marginTop: "40px" }}>
          <div style={{
            padding: "30px",
            background: "linear-gradient(135deg, rgba(205, 95, 248, 0.1), rgba(110, 64, 201, 0.1))",
            border: "1px solid var(--primary)",
            borderRadius: "20px",
            boxShadow: "0 0 30px var(--accent-glow)"
          }}>
            <h3 style={{ color: "var(--primary)", fontFamily: "var(--font-display)", marginBottom: "10px" }}>Attention Recruiters & Hiring Managers</h3>
            <p style={{ fontSize: "1.1rem", color: "#fff", fontWeight: "600" }}>
              "I am not just another developer; I am a builder who understands the ROI of engineering.
              If you are looking for a high-impact individual ready to drive value in your organization — <span className="highlight">I am ready to join and build with you.</span>"
            </p>
          </div>
        </section>

        {/* Contact/Collaboration */}
        <section className="section delay-4 contact-section">
          <p style={{ fontSize: "1.2rem", marginBottom: "40px", color: "var(--text-dim)", textAlign: "center" }}>
            I’m always open to collaborating with high-impact SaaS companies,
            ambitious builders, and teams solving difficult technical problems.
          </p>

          <div className="status-pills">
            <span className="pill active">Still learning</span>
            <span className="pill active">Still building</span>
            <span className="pill">Remote Open</span>
            <span className="pill">Open for Opportunities</span>
          </div>

          <div style={{ marginTop: "60px" }}>
            <a href="https://github.com/selvasaravanaraj" target="_blank" rel="noopener noreferrer" className="button-link">GitHub Profile</a>
            <a href="https://wa.me/918248353916" target="_blank" rel="noopener noreferrer" className="button-link" style={{ background: "#25D366", color: "#fff" }}>WhatsApp: 8248353916</a>
            <a href="mailto:selva@leada.in" className="button-link" style={{ background: "transparent", border: "1px solid var(--border)", color: "#fff" }}>Get in Touch</a>
          </div>

          <div style={{ marginTop: "100px", borderTop: "1px solid var(--border)", paddingTop: "40px", textAlign: "center" }}>
            <p style={{ fontSize: "1.5rem", fontStyle: "italic", color: "#fff", marginBottom: "10px" }}>
              "Still learning. Still building."
            </p>
            <p style={{ fontSize: "0.9rem", color: "var(--text-dim)" }}>
              A long-term pursuit of mastery.
            </p>
          </div>

          <p style={{ marginTop: "40px", fontSize: "0.8rem", color: "rgba(255,255,255,0.2)", textAlign: "center" }}>
            © {new Date().getFullYear()} Selva Saravana Raj • Built with Mastery.
          </p>
        </section>

      </main>
    </div>
  );
}

export default App;
